const getters = {
    projects: (state) => state.projects,
    projectId: (state) => state.projectId,
    tasks: (state) => state.tasks,
    subtasks: (state) => state.subtasks,
    assignees: (state) => state.assignees,
    milestones: (state) => state.milestones,
    loading: state => state.loading
};

export default getters;